import React, { ReactElement, useContext, useEffect, useState } from 'react';
import { ToastProvider } from 'react-toast-notifications';
import Wrapper from '../layout/Wrapper/Wrapper';
import { Toast, ToastContainer } from '../components/bootstrap/Toasts';
import Loader from '../components/Loader';
import Portal from '../layout/Portal/Portal';
import { ReactNotifications } from 'react-notifications-component';
import { requestInterceptor, responseInterceptor } from '../interceptors/axios.interceptor';
import { AlertsContext, AlertsContextProps } from '../contexts/alertsContext';
import { SOCKET_ALERT } from '../constants/socket.constants';
import { io } from 'socket.io-client';
import { WEBSOCKET } from '../constants/environment.constants';
import { IAlert } from '../common/io/alert.response';
import { getLoggedUserId } from '../common/function/utilities';
import showNotification from '../components/extras/showNotification';
import { t } from 'i18next';
import { TimerProvider } from '../contexts/timerContext';
import TimerBox from '../components/evohunt/common/ui/TimerBox';
import { getFromSessionStorage } from '../utils/storage.util';
import PlanBox from '../components/evohunt/common/ui/PlanBox';

const App = (): ReactElement => {
	const [loading, setLoading] = useState<number>(0);
	const { setAlerts } = useContext<AlertsContextProps>(AlertsContext);

	const addLoading = (): void => {
		setLoading((prevLoading: number): number => prevLoading + 1);
	};

	const removeLoading = (): void => {
		setLoading((prevLoading: number): number => (prevLoading > 0 ? prevLoading - 1 : 0));
	};

	useEffect((): void => {
		requestInterceptor(addLoading, removeLoading);
		responseInterceptor(removeLoading);

		const socket = io(WEBSOCKET);
		socket.on(SOCKET_ALERT, (data: IAlert): void => {
			if (!data.idUser || data.idUser === getLoggedUserId()) {
				let notificationMessage: string = '';
				if ((data.notifications ?? 0) > 0) {
					notificationMessage = t('socket.alerts.notification' + ((data.notifications ?? 0) === 1 ? '' : 's'), { count: data.notifications });
				} else if ((data.messages ?? 0) > 0) {
					notificationMessage = t('socket.alerts.message' + ((data.messages ?? 0) === 1 ? '' : 's'), { count: data.messages });
				} else if ((data.tests ?? 0) > 0) {
					notificationMessage = t('socket.alerts.test' + ((data.tests ?? 0) === 1 ? '' : 's'), { count: data.tests });
				} else if ((data.videos ?? 0) > 0) {
					notificationMessage = t('socket.alerts.video' + ((data.videos ?? 0) === 1 ? '' : 's'), { count: data.videos });
				}
				showNotification(<></>, <h5>{notificationMessage}</h5>, 'success');

				const savedAlerts: any = getFromSessionStorage('alerts');
				const currentAlerts: IAlert = savedAlerts ? JSON.parse(savedAlerts) : {};

				setAlerts({
					notifications: (currentAlerts.notifications ?? 0) + (data.notifications ?? 0),
					messages: (currentAlerts.messages ?? 0) + (data.messages ?? 0),
					tests: (currentAlerts.tests ?? 0) + (data.tests ?? 0),
					videos: (currentAlerts.videos ?? 0) + (data.videos ?? 0),
				});
			}
		});
	}, []);

	return (
		<TimerProvider>
			<ToastProvider components={{ ToastContainer, Toast }}>
				{loading > 0 && <Loader />}
				<div className='app'>
					<Wrapper />
					<TimerBox />
					<PlanBox />
				</div>
				<Portal id='portal-notification'>
					<ReactNotifications />
				</Portal>
			</ToastProvider>
		</TimerProvider>
	);
};

export default App;
